var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"mg_theme"}},[_c('svg-sprites'),_vm._v(" "),_c('header-tag'),_vm._v(" "),_c('search-banner'),_vm._v(" "),_c('v-content',[_c('nuxt')],1),_vm._v(" "),_c('footer-tag')],1)}
var staticRenderFns = []

export { render, staticRenderFns }